import ConfirmButton from '@sayyesschool/frontend/components/confirm-button';
import { Flex, List, Text } from '@sayyesschool/frontend/ui-components';

import MembershipRegistrationsCounter from '@/components/memberships/membership-registrations-counter';

export default function MembershipsList({ memberships, onClick, onDelete }) {
    return (
        <List className="MembershipsList">
            {memberships.map(membership =>
                <List.Item
                    key={membership.id}
                    content={
                        <Flex
                            align="center"
                            gap="l"
                        >
                            <Flex dir="column">
                                <Text
                                    content={`${membership.price} руб.`}
                                    type="body-md"
                                />

                                <Text
                                    content={`${membership.startDateString} - ${membership.endDateString}`}
                                    type="body-sm"
                                />
                            </Flex>

                            <MembershipRegistrationsCounter membership={membership} />
                        </Flex>
                    }
                    endAction={
                        <ConfirmButton
                            icon="delete"
                            title="Удалить"
                            message="Удалить абонемент?"
                            color="danger"
                            closeAfterConfirm
                            onConfirm={() => onDelete(membership.id)}
                        />
                    }
                />
            )}
        </List>
    );
}